import React from "react";
import { useSelector, connect } from "react-redux";
import { styled } from "@acko-tech/building-blocks.ui.common";

import { getInrFormat } from "@utils/inrFormatter";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import { getWidgetSpecificProps } from "@utils/index";

interface IFooterPrice extends CommonProps {
  price: string | number;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const PriceContainer = styled.div`
  width: max-content;
  color: #040222;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  position: relative;

  ::before {
    position: absolute;
    content: "₹";
    left: -10px;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    color: #040222;
  }

  ::after {
    position: absolute;
    content: "+18% GST";
    right: -64px;
    bottom: 0px;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #040222;
  }
`;

const FooterPrice = (props: IFooterPrice) => {
  const { selectedPrice } = useSelector(({ globalState }: any) => {
    return {
      selectedPrice: globalState?.price
    };
  });

  const { price, is_visible } = props;

  const displayPrice = selectedPrice || price;
  const formattedDisplayPrice =
    typeof displayPrice === "string"
      ? displayPrice
      : getInrFormat(displayPrice);

  return is_visible ? (
    <PriceContainer> {formattedDisplayPrice}</PriceContainer>
  ) : null;
};

export default connect(mapStateToProps)(FooterPrice);
